import { Injectable } from "@angular/core";
import { OAuthService } from "angular-oauth2-oidc";

import { map } from "rxjs/operators";
import { ConfigurationService } from "./configuration.service";
import { DataService } from "./data.service";

@Injectable({ providedIn: "root" })
export class UserSettingsService {
  private url = "";

  constructor(
    private service: DataService,
    private configurationService: ConfigurationService,
  ) {
    if (this.configurationService.isReady) {
      this.url = this.configurationService.serverSettings.userSettingsApiUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(
        (x) => (this.url = x?.userSettingsApiUrl),
      );
    }
  }

  getAvailableSystems() {
    const url = `${this.url}/api/v1/user/getAvailableSystems`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  }

  public setCurrentSystem = async (
    userId: number,
    systemId: string,
  ): Promise<any> => {
    const url = `${this.url}/api/v1/user/setCurrentSystem?userId=${userId}&systemId=${systemId}`;

    return this.service.get(url).pipe(
      map((response: any) => {
        return response;
      }),
    );
  };

  public async getCurrentSystem(userId: number, applicationSystem) {
    const allSystems = await this.getAvailableSystems().toPromise();
    const system = allSystems.find(
      (s) => s.normalizedName === applicationSystem,
    );
    return system;
  }
}
